// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import DatePickerWithPopper from 'components/atoms/DatePickerWithPopper/DatePickerWithPopper';
import { FieldsInputTitle } from 'pages/Forms/FormResults/FormResultDetails/ResultInputs/components/common/FieldsInputTitle';
import useCustomForm from 'pages/Forms/context/useCustomForm';
import ClearSelection from '../components/ClearSelection';

const DateFormFieldPreview = ({
  element,
  answer,
  handleDirty,
  updateAnswerInPrefilledElements,
  shouldBeReadOnly,
}) => {
  const initialDate = answer ? new Date(answer) : '';
  const [, { setAnswer }] = useCustomForm();
  const [selectedDate, setSelectedDate] = useState(initialDate);

  const handleClearSelection = () => {
    setSelectedDate('');
    setAnswer(element?.id, '');
    if (updateAnswerInPrefilledElements) {
      updateAnswerInPrefilledElements(element?.id, '', element?.type);
    }
    handleDirty();
  };
  const handleChange = (value) => {
    if (value) {
      const adjustedDate = new Date(
        value?.getTime() - value?.getTimezoneOffset() * 60000,
      );
      setSelectedDate(adjustedDate);
      const formattedDate = adjustedDate?.toISOString()?.split('T')[0];
      setAnswer(element?.id, formattedDate);
      if (updateAnswerInPrefilledElements) {
        updateAnswerInPrefilledElements(
          element?.id,
          formattedDate,
          element?.type,
        );
      }
    } else {
      setSelectedDate('');
      setAnswer(element?.id, '');
      if (updateAnswerInPrefilledElements) {
        updateAnswerInPrefilledElements(element?.id, '', element?.type);
      }
    }
    handleDirty();
  };

  useEffect(() => {
    if (answer) {
      const adjustedDate = new Date(answer);
      setSelectedDate(adjustedDate);
    }
  }, [answer]);

  return (
    <Box key={element?.id} m={1}>
      <FieldsInputTitle
        label={element?.label || element?.name}
        isRequired={element?.isRequired}
      />
      <Box width={400}>
        <DatePickerWithPopper
          startDate={selectedDate}
          dateChangeHandler={(value) => handleChange(value)}
          disabled={shouldBeReadOnly}
        />
      </Box>
      {!element?.isRequired && selectedDate && !shouldBeReadOnly && (
        <ClearSelection handleClear={handleClearSelection} />
      )}
    </Box>
  );
};

export default DateFormFieldPreview;
